import React from 'react';
import './IndustriesSection.css';
import bg from '../assets/industries.jpeg';

export default function IndustriesSection() {
  return (
    <section className="full-section industries-section">
      <div className="fw-inner container">
        <div className="cats-header">
          <h3 className="cats-title">Powering progress across industries</h3>
        </div>

        <div className="industries-marquee" aria-hidden>
          <div className="industries-track">
            <div className="industry-slide" style={{ backgroundImage: `url(${bg})` }} />
            <div className="industry-slide" style={{ backgroundImage: `url(${bg})` }} />
            <div className="industry-slide" style={{ backgroundImage: `url(${bg})` }} />
            <div className="industry-slide" style={{ backgroundImage: `url(${bg})` }} />
          </div>
        </div>
      </div>
    </section>
  );
}
